import { FrameIcon } from '@/components/Viewer/ViewerFrame';

/**
 * The PDF reader's glyphs — Lucide outlines, hand-copied, as every glyph in
 * this workspace is (ADR-0053: there is no icon library here).
 *
 * They lived at the bottom of `PdfViewer.tsx` until that file's two toolbars
 * became four components. `FrameIcon` from `Viewer/ViewerFrame` supplies the
 * shared 20px box and stroke, so nothing here repeats it.
 *
 * The chevrons are **not** here: both readers step something, so they are
 * exported from `ViewerFrame` beside `FrameIcon` itself.
 */

export function DownloadIcon() {
  return (
    <FrameIcon>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </FrameIcon>
  );
}

export function MinusIcon() {
  return (
    <FrameIcon>
      <path d="M5 12h14" />
    </FrameIcon>
  );
}

export function PlusIcon() {
  return (
    <FrameIcon>
      <path d="M12 5v14M5 12h14" />
    </FrameIcon>
  );
}

export function UndoIcon() {
  // Lucide `undo-2`.
  return (
    <FrameIcon>
      <path d="M9 14 4 9l5-5" />
      <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11" />
    </FrameIcon>
  );
}

export function FitWidthIcon() {
  return (
    <FrameIcon>
      <path d="M3 8v8M21 8v8M7 12h10M7 12l3-3M7 12l3 3M17 12l-3-3M17 12l-3 3" />
    </FrameIcon>
  );
}

export function FitPageIcon() {
  return (
    <FrameIcon>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M9 8h6M9 12h6M9 16h4" />
    </FrameIcon>
  );
}

export function RotateIcon() {
  return (
    <FrameIcon>
      <path d="M21 12a9 9 0 1 1-3-6.7" />
      <path d="M21 3v6h-6" />
    </FrameIcon>
  );
}

/**
 * The pencil — the free-draw tool's glyph.
 *
 * Deliberately the pen-nib the sign button used to show for somebody with no
 * signature: that button no longer needs it (it shows `AddSignatureIcon` now),
 * and drawing on the page is the thing the mark reads as.
 */
export function PencilIcon() {
  return (
    <FrameIcon>
      <path d="M12 19h8" />
      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </FrameIcon>
  );
}

/**
 * The "set up your signature" glyph — a bordered page with a pen, shown on the
 * sign button for somebody who may sign but has drawn no mark yet. It reads as
 * "go make one" where the bare pen-nib (now the pencil) read as "place one".
 */
export function AddSignatureIcon() {
  return (
    <FrameIcon>
      <path d="M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z" />
    </FrameIcon>
  );
}

export function TextFieldIcon() {
  return (
    <FrameIcon>
      <polyline points="4 7 4 4 20 4 20 7" />
      <line x1="12" y1="4" x2="12" y2="20" />
      <line x1="9" y1="20" x2="15" y2="20" />
    </FrameIcon>
  );
}
